"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _fp = require("lodash/fp");
var getBaseReducers = function getBaseReducers(_ref) {
  var action = _ref.action,
    state = _ref.state;
  return {
    error: function error() {
      return (0, _fp.merge)(state, {
        error: action.error,
        isLoading: false
      });
    },
    progress: function progress() {
      return (0, _fp.merge)(state, {
        error: null,
        isLoading: true
      });
    },
    success: function success() {
      return (0, _fp.merge)(state, {
        error: null,
        isLoading: false
      });
    }
  };
};
var _default = exports["default"] = getBaseReducers;
module.exports = exports.default;